<div 
  [ngClass]="{ 'h-9 w-9': size === 3 }"
  class="flex items-center justify-center">
  <i
    *ngIf="availability?.icon; else availabilityText"
    [ngClass]="[availability?.color, sizes[size].icon]"
    class="material-icons">
    {{ availability.icon }}
  </i>

  <ng-template #availabilityText> 
    <span [ngClass]="sizes[size].text">
      <span [ngClass]="{ 'text-red-500 font-bold': availability?.code === 'PEN' }">
        {{ availability?.code }}
      </span>
    </span>
  </ng-template>
</div>